var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ValidationObserver", { ref: "form", attrs: { slim: "" } }, [
    _c(
      "form",
      {
        staticClass: "form-horizontal",
        attrs: {
          role: "form",
          name: "vm.numberForm",
          novalidate: "",
          disabled: _vm.submitting
        },
        on: {
          submit: function($event) {
            $event.preventDefault()
          }
        }
      },
      [
        _c(
          "fieldset",
          [
            _c("Field", {
              attrs: {
                label: _vm.$t("NUMBER_COUNTRY"),
                "has-tooltip": true,
                "tooltip-text": _vm.$t("NUMBER_COUNTRY_TT")
              },
              scopedSlots: _vm._u([
                {
                  key: "element",
                  fn: function() {
                    return [
                      _c("ValidationProvider", {
                        ref: "country",
                        attrs: { rules: "required", slim: "" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function({ classes }) {
                              return [
                                _c("div", { class: classes }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-sm-4 col-md-3" },
                                    [
                                      _c("CountrySelector", {
                                        attrs: {
                                          full: "",
                                          "available-countries":
                                            _vm.availableCountries,
                                          name: "country",
                                          placeholder: "Enter country"
                                        },
                                        model: {
                                          value: _vm.input.country,
                                          callback: function($$v) {
                                            _vm.$set(_vm.input, "country", $$v)
                                          },
                                          expression: "input.country"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("p", {
                                        directives: [
                                          {
                                            name: "t",
                                            rawName: "v-t",
                                            value:
                                              "NUMBERS_CONTACT_SUPPORT_MESSAGE",
                                            expression:
                                              "'NUMBERS_CONTACT_SUPPORT_MESSAGE'"
                                          }
                                        ],
                                        staticClass: "m-t-10"
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("label", {
                                    directives: [
                                      {
                                        name: "t",
                                        rawName: "v-t",
                                        value: "REQUIRED",
                                        expression: "'REQUIRED'"
                                      }
                                    ],
                                    staticClass:
                                      "col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                                  })
                                ])
                              ]
                            }
                          }
                        ])
                      })
                    ]
                  },
                  proxy: true
                }
              ])
            }),
            _vm._v(" "),
            !_vm.isPublisherOrManager
              ? _c("Field", {
                  attrs: {
                    label: _vm.$t("NUMBER_CHARGE_ACCOUNT"),
                    "has-tooltip": true,
                    "tooltip-text": _vm.$t("NUMBER_CHARGE_ACCOUNT_TT")
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "element",
                        fn: function() {
                          return [
                            _c("ValidationProvider", {
                              ref: "billCard",
                              attrs: { rules: "", slim: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ classes }) {
                                      return [
                                        _c("div", { class: classes }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "col-sm-4 col-md-3"
                                            },
                                            [
                                              _c("NzToggle", {
                                                attrs: {
                                                  name: "billCard",
                                                  disabled: false
                                                },
                                                model: {
                                                  value: _vm.input.billCard,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.input,
                                                      "billCard",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "input.billCard"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ])
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                1725224746
                              )
                            })
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    1627297279
                  )
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.config.hasLocalNumbers
              ? [
                  _c("Field", {
                    attrs: {
                      label: _vm.$t("INPUT_LABEL_NUMBER_TYPE"),
                      "has-tooltip": true,
                      "tooltip-text": _vm.$t("INPUT_LABEL_NUMBER_TYPE_TT")
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "element",
                          fn: function() {
                            return [
                              _c("ValidationProvider", {
                                ref: "numberType",
                                attrs: { rules: "required", slim: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function({ classes }) {
                                        return [
                                          _c("div", { class: classes }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "col-sm-4 col-md-3"
                                              },
                                              [
                                                _c("input", {
                                                  attrs: {
                                                    type: "hidden",
                                                    name: "numberType"
                                                  },
                                                  domProps: {
                                                    value: _vm.input.numberType
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("MultipleToggle", {
                                                  attrs: {
                                                    value: _vm.input.numberType,
                                                    options:
                                                      _vm.config.numberOptions
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      _vm.input.numberType =
                                                        $event.value
                                                    }
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("label", {
                                              directives: [
                                                {
                                                  name: "t",
                                                  rawName: "v-t",
                                                  value: "REQUIRED",
                                                  expression: "'REQUIRED'"
                                                }
                                              ],
                                              staticClass:
                                                "col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                                            })
                                          ])
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  3062407649
                                )
                              })
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      1295967958
                    )
                  }),
                  _vm._v(" "),
                  _c("Field", {
                    attrs: {
                      label: _vm.$t("INPUT_LABEL_PREFIX"),
                      "has-tooltip": true,
                      "tooltip-text": _vm.$t("INPUT_LABEL_PREFIX_TT")
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "element",
                          fn: function() {
                            return [
                              _c("ValidationProvider", {
                                ref: "prefix",
                                attrs: { rules: "no800", slim: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function({ errors, classes }) {
                                        return [
                                          _c("div", { class: classes }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "col-sm-4 col-md-2"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.input.prefix,
                                                      expression: "input.prefix"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  attrs: {
                                                    placeholder: "Optional",
                                                    type: "text",
                                                    name:
                                                      "incomingQueryStringName",
                                                    autocomplete: "off"
                                                  },
                                                  domProps: {
                                                    value: _vm.input.prefix
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        _vm.input,
                                                        "prefix",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                errors.length > 0
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "text-danger"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(errors[0]) +
                                                            "\n                  "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ])
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  3430123111
                                )
                              })
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      108693473
                    )
                  })
                ]
              : _vm._e(),
            _vm._v(" "),
            !_vm.isPublisher
              ? [
                  _c("Field", {
                    attrs: {
                      label: _vm.$t("INPUT_LABEL_PUBLISHER"),
                      "has-tooltip": true,
                      "tooltip-text": _vm.$t("INPUT_LABEL_PUBLISHER_TT")
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "element",
                          fn: function() {
                            return [
                              _c("ValidationProvider", {
                                ref: "publisher",
                                attrs: { rules: "", slim: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function({ classes }) {
                                        return [
                                          _c("div", { class: classes }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "col-sm-4 col-md-3"
                                              },
                                              [
                                                _c("publisher-selector", {
                                                  attrs: {
                                                    name: "publisher",
                                                    placeholder: _vm.$t(
                                                      "NUMBER_SELECT_AFFILIATE"
                                                    ),
                                                    clearable: true,
                                                    "no-options-text": "none",
                                                    "numbers-only": false,
                                                    prefix: "",
                                                    rules: ""
                                                  },
                                                  model: {
                                                    value: _vm.input.publisher,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.input,
                                                        "publisher",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "input.publisher"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ])
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  476092287
                                )
                              })
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      3952462952
                    )
                  }),
                  _vm._v(" "),
                  _c("Field", {
                    attrs: {
                      label: _vm.$t("NUMBER_MULTIPLE_NUMBERS"),
                      "has-tooltip": true,
                      "tooltip-text": _vm.$t("NUMBER_MULTIPLE_NUMBERS_TT")
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "element",
                          fn: function() {
                            return [
                              _c("ValidationProvider", {
                                ref: "amount",
                                attrs: {
                                  mode: "lazy",
                                  name: "Amount",
                                  rules: "between:1,100",
                                  slim: ""
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function({ classes, failedRules }) {
                                        return [
                                          _c("div", { class: classes }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "col-sm-4 col-md-2"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model.trim",
                                                      value: _vm.input.amount,
                                                      expression:
                                                        "input.amount",
                                                      modifiers: { trim: true }
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  attrs: {
                                                    placeholder: "1",
                                                    type: "number",
                                                    pattern: "\\d*",
                                                    name: "amount",
                                                    autocomplete: "off"
                                                  },
                                                  domProps: {
                                                    value: _vm.input.amount
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        _vm.input,
                                                        "amount",
                                                        $event.target.value.trim()
                                                      )
                                                    },
                                                    blur: function($event) {
                                                      return _vm.$forceUpdate()
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  { staticClass: "error" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        failedRules.between
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ])
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  3984543536
                                )
                              })
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      1615602536
                    )
                  })
                ]
              : _vm._e()
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "row m-b-10" }, [
          _c(
            "div",
            { staticClass: "col-sm-7 col-md-7 col-sm-offset-3" },
            [
              _c(
                "PrimaryButton",
                {
                  attrs: {
                    size: "sm",
                    type: "submit",
                    "show-loader-on-form": _vm.submitting
                  },
                  on: { click: _vm.onSubmit }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("NUMBER_CREATE_BUTTON")) +
                      "\n        "
                  )
                ]
              ),
              _vm._v(" "),
              !_vm.isNumberPool && !_vm.currentCampaign
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-danger btn-sm m-l-15",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.$emit("cancel")
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          " + _vm._s(_vm.$t("CANCEL")) + "\n        "
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ]),
        _vm._v(" "),
        _vm.showModal
          ? _c(
              "confirmation-modal",
              {
                ref: "modal",
                attrs: {
                  title: _vm.$t("NUMBER_ORDER_CONFIRMATION_MODAL_TITLE"),
                  "allow-modal-to-be-closed": false,
                  "cancel-button-text": _vm.$t("CANCEL"),
                  "confirm-action-text": _vm.$t(
                    "NUMBER_ORDER_CONFIRMATION_MODAL_CONFIRM_ACTION"
                  ),
                  "show-header-close-button": false
                },
                on: {
                  confirm: function($event) {
                    return _vm.$emit("confirm", true)
                  },
                  close: function($event) {
                    return _vm.$emit("confirm", false)
                  }
                }
              },
              [
                _c("div", [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t("NUMBER_ORDER_CONFIRMATION_MODAL_MESSAGE", {
                          orderAmount: `${_vm.input.amount}`
                        })
                      ) +
                      "\n      "
                  )
                ])
              ]
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }